import React from "react";
import { HStack, IconButton } from "@chakra-ui/react";
import Menu from "./Menu";
import { ReactComponent as NavBarLogoPay } from "../..../../../../../assets/icons/navBarLogoPay.svg";
import type { IHeaderProps } from "../../index";
import { observer } from "mobx-react-lite";

const LeftSide: React.FC<IHeaderProps> = observer(({ contents, onTriggerTagging }) => {

	return (
		<HStack gap={"56px"}>
			<IconButton
				bg={"transparent"}
				_hover={{ bg: "transparent", cursor: "pointer" }}
				_active={{ bg: "transparent" }}
				as={NavBarLogoPay}
				aria-label={"Vivo Logo"}
				h={"48px"}
				paddingInline={0}
				onClick={() => window.open("https://vivomoney.com.br", "_self")}
			/>
			<HStack gap={"22px"} style={{ margin: 0 }}>
				{contents.map(({ menu, subMenu }) => (
					<Menu menu={menu} subMenu={subMenu} key={menu.label} onTriggerTagging={onTriggerTagging} />
				))}
			</HStack>
		</HStack>
	);
});

export default LeftSide;
